import React, { useState } from 'react'
import { DatePicker, Modal, Typography } from 'antd'
import _pick from 'lodash/pick'
import dateFnsGenerateConfig from 'rc-picker/es/generate/dateFns'
import { FormActionFormActionScheduleUnitNameChoices } from '@/__gen/types'
import { TEMP_ID_PREFIX } from '@/utils/constants'
import buttonStyle from '@sass/common/button.module.sass'
import generalStyle from '@sass/common/general.module.sass'
import { MiscDetails, SetMiscDetails, emptyDetails } from '../../common/misc-details'
import { emptyAssignee } from '../../common/select-assignee'
import { Assignee, SelectAssignee, isAssigneeValid } from '../../common/select-assignee'
import { CycleInput } from '../common'

const { Title } = Typography

export type AddFormState = {
	id: string
	deleted: boolean
	dueAt: Date
	unitAmount: number | null
	unitName: FormActionFormActionScheduleUnitNameChoices
} & Assignee &
	MiscDetails

export type PartialScheduleState = { [K in keyof AddFormState]?: AddFormState[K] }

type Props = {
	initialState: AddFormState | null
	stageChange: (s: AddFormState | null) => void
	show: boolean
	setShow: (show: boolean) => void
}

const DateFnsDatePicker = DatePicker.generatePicker<Date>(dateFnsGenerateConfig)

export const Add = ({ initialState, stageChange, show, setShow }: Props) => {
	const [formState, setFormState] = useState<AddFormState>({
		id: `${TEMP_ID_PREFIX}${Math.floor(Math.random() * 9999999)}`,
		deleted: false,
		dueAt: new Date(),
		unitAmount: 12,
		unitName: FormActionFormActionScheduleUnitNameChoices.Months,
		...emptyAssignee(),
		...emptyDetails(),
	})
	const [error, setError] = useState<boolean>(false)
	const onDatePick = (date: Date | null, dateString: string | string[]) => {
		if (date) {
			// Don't allow null dates
			setFormState({ ...formState, dueAt: date })
		}
	}

	const commit = () => {
		if (!isAssigneeValid(formState) || !formState.unitAmount) {
			setError(true)
			return
		}
		stageChange(formState)
		setShow(false)
	}

	return (
		<Modal
			title="Add Schedule"
			open={show}
			maskClosable
			onCancel={() => setShow(false)}
			footer={null}
			width={800}
		>
			<Title level={5}>Start Date</Title>
			<DateFnsDatePicker onChange={onDatePick} value={formState.dueAt} placeholder="Start Date" />
			<br />
			<br />
			<Title level={5}>Period</Title>
			<CycleInput
				value={{ unitName: formState.unitName, unitAmount: formState.unitAmount }}
				onChange={(cycle) => setFormState({ ...formState, ...cycle })}
			/>

			<br />
			<br />
			<SelectAssignee
				update={(a) => setFormState({ ...formState, ...a })}
				assignee={formState}
				disabledUsers={[]}
				disabledAnswers={[]}
			/>
			<SetMiscDetails
				update={(a) => {
					setFormState({ ...formState, ...a })
				}}
				details={formState}
			/>
			{error && <div className={generalStyle.error}>Please ensure all fields are correct</div>}
			<button className={buttonStyle.primarySolid} onClick={commit}>
				Save
			</button>
		</Modal>
	)
}
